/* eslint-disable react/style-prop-object */
import { Breadcrumb } from "antd";
import Button from "../Helpers/Button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import trans, { isRTL } from "../../utils";
import { useSelector } from "react-redux";
import ExportDropdown from "./AntDropdown";

export default function BreadCrumb({
	title,
	add,
	onClick,
	type,
	text,
	secClick,
}) {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const inf = useSelector((state) => state.users.user);

	// Generate breadcrumb items from pathname
	const getBreadcrumbItems = () => {
		const pathSegments = pathname.split("/").filter((i) => i);

		const items = [
			{
				title: (
					<span className="text-primary cursor" onClick={() => navigate("/")}>
						{trans("Home")}
					</span>
				),
			},
			...pathSegments.map((seg, index) => {
				// Build path up to this segment
				const url = "/" + pathSegments.slice(0, index + 1).join("/");

				const isLast = index === pathSegments.length - 1;

				return {
					title: isLast ? (
						<span>{trans(seg)}</span>
					) : (
						<span className="text-primary cursor" onClick={() => navigate(url)}>
							{trans(seg)}
						</span>
					),
				};
			}),
		];

		return items;
	};

	return (
		<div className="bg-white p-16 border-bottom">
			<div className="flex-between">
				<div>
					<Breadcrumb
						separator={
							<img
								src={`${process.env.PUBLIC_URL}/assets/rightarrow.svg`}
								alt="arrow"
								className="mx-2"
								style={{ transform: isRTL && "rotate(180deg)" }}
							/>
						}
						items={getBreadcrumbItems()}
					/>
				</div>

				{(inf.administrator === true ||
					inf.deviceLimit > 0 ||
					inf.deviceLimit === -1 ||
					inf.userLimit > 0) && (
					<div className="flex-between gap-8">
						{type === "vehicles" && (
							<Button
								text={trans("Bulk Upload")}
								onClick={secClick}
								type={"default"}
							/>
						)}
						{add && <Button text={add} onClick={onClick} type={"primary"} />}
						{type === "reports" && <ExportDropdown />}
					</div>
				)}
			</div>
		</div>
	);
}
